export enum ItemReceiptStatusEnum {
    InProgress = 1,
    Done = 2
}